module.exports = __webpack_public_path__ + "static/media/Watcher.38ea3331.jpeg";